export class CsvModes {
  public static seriesDeals = 'Series_Deals';
  public static seriesHoldings = 'Series_Holdings';
  public static InvestmentType = 'Investment_Type';
  public static quarterlyRollForwardDeals = 'Quarterly_Roll_Forward_Deals';
  public static quarterlyRollForwardHoldings = 'Quarterly_Roll_Forward_Holdings';
  public static assets = 'Assets';
  public static qRollForwardInvestmentType = 'Quarterly_Roll_Forward_Investment_Type';
}
